<template>
  <v-btn
    v-if="!dialog"
    color="black"
    dark
    @click="dialog = true"
    block
  >
    {{ type === 'categories' ? 'categorias' : 'lugares' }}
  </v-btn>
  <v-row justify="center" v-else>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!--template v-slot:activator="{ on, attrs }">
        <v-btn
          color="orange"
          dark
          v-bind="attrs"
          v-on="on"
        >
          css
        </v-btn>
      </template-->
      <v-card style="background-color: #CCCCCC;">
        <v-toolbar
          dark
          color="primary"
          elevation="0"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ type === 'categories' ? 'Categorias' : 'Lugares' }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <v-row
          style="padding: 20px;"
        >
          <v-col
            cols="12"
            sm="8"
          >
            <div
              v-for="(item, index) of values"
              :key="index"
            >
              <v-btn
                @click="handleEdit(item)"
                block
                text
                :color="item.Color"
                :disabled="editedItem ? true : false"
              >
                {{ item.Name.es || item.Name.en || item.ID }}
              </v-btn>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            v-if="!editedItem"
            style="padding: 10px;"
          >
            <v-btn
              @click="handleAdd"
              color="primary"
              block
            >
              añadir
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            v-if="editedItem"
            style="padding: 10px;"
          >
            <v-row
            >
              <v-col
                cols="12"
                sm="12"
                style="padding: 10px 20px;"
              >
                <translate
                  v-model="editedItem.Name"
                  :languages="languages"
                  :label="$t('booking.name', locale)"
                  @input="handleChangeIsModified"
                  type="text"
                />
              </v-col>
              <v-col
                v-if="type==='categories'"
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="editedItem.Color"
                  outlined
                  label="Color"
                  hide-details
                />
              </v-col>
              <v-col
                v-if="type==='categories' && totemTactilIcons"
                cols="12"
                sm="12"
              >
                <v-select
                  v-model="editedItem.TotemTactilIcon"
                  :items="totemTactilIcons"
                  label="Totem act tactil"
                  outlined
                  hide-details
                  itemText="name"
                  itemValue="id"
                />
              </v-col>
              <v-col
                v-if="type==='categories'"
                cols="12"
                sm="12"
              >
                <select-image
                  :image="editedItem.Image"
                  :onChange="handleChangeImage"
                  :locale="locale"
                  :folder="workspaceID"
                  style="margin-left: 0px;margin-top:10px;"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <action-buttons
                  :id="editedItem.ID"
                  :onDeleteItem="handleDelete"
                  :onSaveItem="handleSave"
                  :onClose="() => { editedItem = null }"
                  :locale="locale"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
const defaultItem = {
  Name: { es: '' }
}
import apiService from '@/services/api'
import Translate from '@/components/Translate'
import ActionButtons from '@/components/ActionButtons'
import SelectImage from '@/components/selectImage/Index'
export default {
  components: {
    Translate,
    ActionButtons,
    SelectImage,
  },
  props: {
    locale: {
      type: String,
      default: 'es',
    },
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    workspaceID: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    values: [],
    editedItem: null,
    totemTactilIcons: null,
  }),
  computed: {
    languages () {
      return ['es', 'en', 'fr', 'de']
    },
  },
  watch: {
    dialog (v) {
      if (v) this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleAdd () {
      this.editedItem = JSON.parse(JSON.stringify(defaultItem))
    },
    handleEdit (v) {
      this.editedItem = JSON.parse(JSON.stringify(v))
    },
    handleDelete (v) {
      apiService.deleteItem('dviewcontent', `v1/system/content-types/${this.id}/${this.type}/`, v)
        .then(() => {
          this.handleGetData()
          this.editedItem = null
        })
    },
    handleChangeImage (v) {
      if (!v) return
      this.editedItem.Image = v.base64
      this.editedItem.newImage = v
      this.editedItem = JSON.parse(JSON.stringify(this.editedItem))
    },
    async handleGetData () {
      try {
        if (!this.id) return
        this.values = await new Promise((resolve) => apiService.getAllWithoutLimit('dviewcontent', `v1/system/content-types/${this.id}/${this.type}`)
          .then(response => {
            response = response.map(item => {
              item.Name = item.Name ? JSON.parse(item.Name) : null
              return item
            })
            resolve(response)
          }))
        this.totemTactilIcons = await new Promise((resolve) => apiService.getAllWithoutLimit('dviewcontent', `v1/system/content-types/${this.id}/totem-tactil-icons`)
          .then(response => {
            resolve(response)
          }))
      } catch (error) {
        console.log(error)
      }
    },
    async handleSave () {
      this.editedItem.ContentTypeID = this.id
      this.editedItem.WorkspaceID = this.workspaceID
      if (this.editedItem.ID) {
        await new Promise((resolve) => apiService.updateItem('dviewcontent', `v1/system/content-types/${this.id}/${this.type}/`, this.editedItem.ID, this.editedItem)
          .then(() => {
            resolve()
          }))
      } else {
        await new Promise((resolve) => apiService.addItem('dviewcontent', `v1/system/content-types/${this.id}/${this.type}`, this.editedItem)
          .then(() => {
            resolve()
          }))
      }

      this.handleGetData()
      this.editedItem = null
    },
    handleChangeIsModified () {

    },
  },
}
</script>
